import { MediaQueries, Spacing } from 'UI'

export default {
  modal: {
    padding: () => Spacing(8, 11),
    margin: () => Spacing(10, 0, 0, 0)
  },
  [`${MediaQueries.tablet}`]: {
    modal: {
      width: '100%',
      padding: () => Spacing(5),
      margin: () => Spacing(4)
    }
  },
  [`${MediaQueries.mobile}`]: {
    modal: {
      width: '100%',
      padding: () => Spacing(5),
      margin: () => Spacing(4)
    }
  }
}
